// NATIVE 
import React, { useEffect } from 'react';


// INSTALLED 
import { useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box,  Card, CardContent, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';



// CUSTOM 
import { useFormikContext } from 'formik';
import { paddingCardsTables } from '../../commons';
import { IModulesPermissions, IUserPermissions } from '../../commons/interfaces';
import { eachWordUpper, userHasPermissionFormatedEdit, userHasPermissionFormatedUser, userHasPermissionFormatSave } from '../../commons/utils';





export const EditUserSystemPermissions = (userWithPermissions:IUserPermissions) => {

  const formikProps:any = useFormikContext();




  // REDUX 
  const { customer_permissions }:any  = useSelector( (state:any) => state.customer );
  

  // USE STATE 
  const [pemisssionsListFormated, setPermissionsListFormated] = React.useState([]);


  //  USE STATE 
  const [modules, setModules] = React.useState<any>([]);
  const [pemisssionsList, setPermissionsList] = React.useState([]);
  const [expanded, setExpanded] = React.useState<string | false>(false);


  const [modulesChecked, setModulesChecked] = React.useState<any>([]);
  const [subModulesFormated, SubModulesFormated] = React.useState(false);

  
  
  // PUT NAME MODULE MAIN MODULE PERMISSIONS 
  const [mainCheck, setMainCheck] = React.useState<any>([]);


  // PUT NAME SUB MODULE PERMISSIONS ACTIONS
  const [actionCheck, setActionCheck] = React.useState<any>([]);
  const [subActionCheck, setSubActionCheck] = React.useState<any>([]);



  // USE EFFECT 
  useEffect(() => {


      if (  userWithPermissions.permissions && userWithPermissions.permissions.length > 0 ) { 


          // console.log('dododogogoogrrrrrrrrr')
          // console.log(userWithPermissions.permissions)
          // console.log(customer_permissions)
          formatPermissionsData(userWithPermissions.permissions, customer_permissions).then( function(result) {
              setPermissionsListFormated(result);
          });
      }


      if (  userWithPermissions.permissions.length == 0  ) { 

            const copy_customer_permissions = JSON.parse(JSON.stringify(customer_permissions));
            copy_customer_permissions.forEach( (item:any) => {
                
                  
                  item.childrens.forEach( (element:any) => {
                
                    element.actions = [];

                    if ( element.childrens.length > 0 ) {
                         
                        element.childrens.forEach( (subElement:any) => {
                            subElement.actions = [];
                        });
                    }


                  });
            });
            setPermissionsListFormated(copy_customer_permissions);
      }

      
  }, [userWithPermissions]);

  useEffect(() => {
        
    if (  pemisssionsListFormated && pemisssionsListFormated.length > 0 && modulesChecked && Object.keys(modulesChecked).length > 0 ) { 
 
      formatPermissionsDataEdit(pemisssionsListFormated, modulesChecked).then( function(result) {
        
          setModulesChecked(result);
      });

      // DESPUES DE FORMATEAR EL ARRAY PARA LOS DATOS CHECKEADOS SE ASIGNAN AL ARRAY QUE SE VA A GUARDAR 
      formatPermissionsDataModules(pemisssionsListFormated, modulesChecked, userWithPermissions.permissions).then( function(result) {
        
        setModules(result);

      });

    }
  
  }, [subModulesFormated]);



  useEffect(() => {
    
    setCheckboxFormated();
    
    setPermissionsList(pemisssionsListFormated);
    SubModulesFormated(!subModulesFormated);

  }, [pemisssionsListFormated]);


  useEffect(() => {
    formikProps.setFieldValue('permissions', modules);
    formikProps.setFieldValue('userPermissionId', userWithPermissions.id);
  }, [modules]);




    // CONST FUNCTIONS 
    const formatPermissionsData = async( user_permissions:any, customer_permissions:any ) => {
      
            return await userHasPermissionFormatedUser(user_permissions, customer_permissions);
      
    }
    

    const formatPermissionsDataEdit = async( pemisssionsListFormated:any, modulesChecked:any ) => {
      
      return await userHasPermissionFormatedEdit(pemisssionsListFormated, modulesChecked);

    }
    

    const formatPermissionsDataModules = async( pemisssionsListFormated:any, modulesChecked:any, user_permissions:any ) => {
      
      return await userHasPermissionFormatSave(pemisssionsListFormated, modulesChecked, user_permissions);

    }


    
    
      const setCheckboxFormated = async() => {
    
    
          let copyPermissions = JSON.parse(JSON.stringify(pemisssionsListFormated));
    

         
         
          let newArr:any = {};
    
          copyPermissions.forEach( (element:any) => { 
    
    
            let elemento:any = {
              [element.permission_slug]: false,
              childrensChecked: {},
              subChildrensCheked: {},
              subModulesChecked: {},
              subSubModulesChecked: {},
            }
    
    
            element.childrens.forEach( function(item:any) { 
    
              // 
              //  if ( item.childrens.length > 0 ) {
              //      elemento.subSubModulesChecked[item.slug] = false; 
              //  }else{
                   
              //  }
                
               elemento.subModulesChecked[item.slug] = false;
               elemento.childrensChecked[item.slug] = {
                   view:    false,
                   create:  false,
                   edit:    false,
                   restore: false,
                   delete:  false
               }
    
    
               item.childrens.forEach( function(element:any) { 
                
                elemento.subSubModulesChecked[element.slug] = false;
                elemento.subChildrensCheked[element.slug] = {
                   view:    false,
                   create:  false,
                   edit:    false,
                   restore: false,
                   delete:  false
                }
               })
    
            });
    
    
            newArr[element.permission_slug] = elemento;
            
          });
    
          
    
          setModulesChecked(newArr);

          // INDICA SI SE CAMBIO UN ESTADO PARA ENVIAR LOS PARAMETROS A SER FORMATEADOS 
          SubModulesFormated(!subModulesFormated);
    
      }
    
      
       
      
      
      const handleChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
          setExpanded(isExpanded ? panel : false);
        };
    
      
      const  setModulesPermissionsParent  = async(event:any, item:IModulesPermissions) => {
    
        const isActive = event.target.checked;
    
        
      
    
        const { text, icon, permission_slug, permisssion_description, related, childrens } = item;
        const permissions = {
           text,
           icon,
           permission_slug,
           permisssion_description,
           related,
           childrens: []
        }


       
    
        
        
        
        if (!isActive) {
            
            let copyPermissions = await JSON.parse(JSON.stringify(modulesChecked));
            let copyActions     = await JSON.parse(JSON.stringify(actionCheck));
            let copySubActions     = await JSON.parse(JSON.stringify(subActionCheck));
          
            await  uncheckAllSubChuldrensFromParentSubmodule(copyPermissions,  item)
    
           
            //  DESACTIVE SUBMODULES  OF MAIN MODULE 
            for (const property in copyPermissions[item.permission_slug].subModulesChecked) {
    
      
              copyPermissions[item.permission_slug].subModulesChecked[property] = false;
    
         
            }
    
             
             //  DESACTIVE SUBMODULES  OF MAIN MODULE WITH CHILDRENS
            for (const property in copyPermissions[item.permission_slug].subSubModulesChecked) {
              
                copyPermissions[item.permission_slug].subSubModulesChecked[property] = false;
    
            }
    
            
            for (const property in copyPermissions[item.permission_slug].subModulesChecked) {
              
              copyPermissions[item.permission_slug].subModulesChecked[property] = false;
    
            }
    
            copySubActions = [];
            copyActions = [];
            setSubActionCheck(copySubActions);
            setActionCheck(copyActions);
    
    
            // DESACTIVE CHILDRENMODULES WHEN CLICK FALSE THE MAIN CHECKBOX 
            for (const property in copyPermissions[item.permission_slug].childrensChecked) {
              copyPermissions[item.permission_slug].childrensChecked[property].view = false;
              copyPermissions[item.permission_slug].childrensChecked[property].create = false;
              copyPermissions[item.permission_slug].childrensChecked[property].edit = false;
              copyPermissions[item.permission_slug].childrensChecked[property].restore = false;
              copyPermissions[item.permission_slug].childrensChecked[property].delete = false;
              
            }
    
            
    
            // setActionCheck
    
            
            setModulesChecked(copyPermissions);
    
    
        }





        


       
    
        // IF THE CHECKBOX IS ACTIVE AND NOT EXIST ELEMENT PUSH ELEMENT TO ARRAY 
        // SEARCH INSIDE CHILDREN AND CHECK IF DE ELEMENT CHILDREN EXIST UPDATE THE DATA 
        // IF NO EXIST PUSH DE CHILDREN 
        if ( isActive && !modules.find((element:any) => element.related === related ) ) {
    
            
            permissions.childrens =  []
            await setModules([...modules, permissions]);
    
        }
    
        // IF THE CHECKBOX IS NOT ACTIVE AND EXIST THE ELEMENT IN ARRAY REMOVE THE ELEMENT 
        if ( !isActive && modules.find((element:any) => element.related === related ) ) {
    
          const filteredPermissions = modules.filter(function(el:IModulesPermissions) { return el.related != related; });
          
          await setModules(filteredPermissions);
    
        }
    
     
        // IF THE CHECKBOX IS ACTIVE TO ACTIVE SUB MODULES
        if ( isActive ) {

           
          //  VERIFICA SI EL MODULO TIENE CHILDRENS Y SI LOS TIENE LOS RECORRE VERIFICANDO SI ESTA CHECKEADO 
          //  CON LA PROPIEDAD isChecked EN CADA ITEM DE EL ARRAY QUE SE RECORRE Y A SU VEZ VERIFICA SI TIENE ACTION 
          //  SI ES ASI QUITA EL DISABLED DE LAS ACCION DE ESE LEMENTO 
          const depeedItemActionCheck = JSON.parse(JSON.stringify(actionCheck));
          const depeedItemSubActionCheck = JSON.parse(JSON.stringify(subActionCheck));
          
           if ( item.childrens && item.childrens.length > 0 ) {
               
                item.childrens.forEach( async(element:any) => {
                    
                      // ELEMENTO SIN SUB CHULDRES 
                      if ( element.isChecked && element.childrens.length <= 0 ) {
                           

                        
                        if ( !actionCheck.includes(element.slug) ) {
                          
                            depeedItemActionCheck.push(element.slug)
                           
                        }
                        
                           
                      }

                      // ELEMENTO CON SUB CHILDRENS 
                      if ( element.isChecked && element.childrens.length > 0 ) {

                        if ( !actionCheck.includes(element.slug) ) {
                          
                          depeedItemActionCheck.push(element.slug)
                         
                        }
                        
                       
                        element.childrens.forEach( ( elementChild:any) => {
                               


                          if ( elementChild.isChecked && !subActionCheck.includes(elementChild.slug) ) {
                          
                              depeedItemActionCheck.push(elementChild.slug)
                              depeedItemSubActionCheck.push(elementChild.slug)
                          }
                          
                           
                        });
                            
                        
                      }


                });

                
           }
           await setSubActionCheck(depeedItemSubActionCheck);
           await setActionCheck(depeedItemActionCheck);
       
            const depeedItem = JSON.parse(JSON.stringify(mainCheck));
            depeedItem.push(related)
            await setMainCheck(depeedItem);
    
        }
    
    
        // IF THE CHECKBOX IS INACTIVE TO INACTIVE SUB MODULES
        if ( !isActive ) {
          
         
          let depeedItem = JSON.parse(JSON.stringify(mainCheck));
          let element = depeedItem.indexOf(related);
          if (element !== -1) {
              depeedItem.splice(element, 1);
          }
    
          setMainCheck(depeedItem);
    
        }
    
        
    
      } 
    
    
      const setModulesPermissionsChildren = async(event:any, item:any, parent:string, action:string, elementParent:any) => {
    
        const isActive = event.target.checked;
    
       
        
        // PONEMOS CHECK EN FALSO PARA TODAS LAS ACCIONES DE ESTE SUB MODULO  
        let copyPermissionsChecked = JSON.parse(JSON.stringify(modulesChecked));
        if ( !isActive ) { 
             
            
    
            //  TIENE CHILDRES 
            if ( copyPermissionsChecked[elementParent.permission_slug] && Object.keys(copyPermissionsChecked[elementParent.permission_slug].childrensChecked).length > 0 ) {
                  
              if ( copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug]  ) {
                   
                   copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug].view    = false;
                   copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug].create  = false;
                   copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug].edit    = false;
                   copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug].restore = false;
                   copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug].delete  = false;
                  
              }
    
          }
    
          
    
          setModulesChecked(copyPermissionsChecked);
    
        }
        
          
          copyPermissionsChecked[elementParent.permission_slug].subModulesChecked[item.slug] = !copyPermissionsChecked[elementParent.permission_slug].subModulesChecked[item.slug];
          setModulesChecked(copyPermissionsChecked);
      
    
         // IF THE CHECKBOX IS ACTIVE AND EXIST ELEMENT PUSH CHILDRENS  ARRAY 
        if ( isActive && modules.find((element:any) => element.related === parent ) ) {
        
          
    
            let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
                
                if ( obj.related == parent ) {
                     const depeedItem = JSON.parse(JSON.stringify(item));
                     depeedItem.parent = parent;
                     depeedItem.actions = [];
                     obj.childrens.push(depeedItem);
                }
    
                return obj;
            });
    
            await setModules(filteredPermissions);
    
        }
    
    
     
        // IF THE CHECKBOX IS NOT ACTIVE AND  EXIST ELEMENT PUSH ELEMENT TO ARRAY 
        if ( !isActive && modules.find((element:any) => element.related === parent ) ) {
    
          let filteredPermissions = modules.map(function (obj:IModulesPermissions, index:any) {
                
            if ( obj.related == parent ) {
                   
    
                  for (let index = 0; index < obj.childrens.length; index++) {
                    
                      if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {
                           obj.childrens.splice(index, 1);
                      }
    
                  }
    
            }
    
            return obj;
    
          });
    
           await setModules(filteredPermissions);
    
    
        }
    
    
    
    
        // IF THE CHECKBOX IS ACTIVE TO ACTIVE SUB MODULES
        if ( isActive ) {
    
           
          const depeedItem = JSON.parse(JSON.stringify(actionCheck));
          depeedItem.push(item.slug)
          setActionCheck(depeedItem);
    
      }
    
    
      // IF THE CHECKBOX IS INACTIVE TO INACTIVE SUB MODULES
      if ( !isActive ) {
        
        let depeedItem = JSON.parse(JSON.stringify(actionCheck));
        let element = depeedItem.indexOf(item.slug);
        if (element !== -1) {
            depeedItem.splice(element, 1);
        }
    
        setActionCheck(depeedItem);
    
      }
        
    
      }
    
      
      const setModulesPermissionsSubModulesChildren = async(event:any, item:any, parent:string, action:string, elementParent:any) => {
    
        const isActive = event.target.checked;
    
        // PONEMOS CHECK EN FALSO PARA TODAS LAS ACCIONES DE ESTE SUB MODULO  
        let copyPermissionsChecked = await JSON.parse(JSON.stringify(modulesChecked));
        let copySubActions     = await JSON.parse(JSON.stringify(subActionCheck));
    
    
        if ( !isActive ) { 
             
            
    
            //  TIENE CHILDRES 
            if ( copyPermissionsChecked[elementParent.permission_slug] && Object.keys(copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked).length > 0 ) {
                  
          
              if ( copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug]  ) {
                   
                   copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug].view    = false;
                   copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug].create  = false;
                   copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug].edit    = false;
                   copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug].restore = false;
                   copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug].delete  = false;
                  
              } // END IF
    
              
    
            } // END IF
          
            let element = copySubActions.indexOf(item.slug);
    
            if (element !== -1) {
              copySubActions.splice(element, 1);
            }
    
            setSubActionCheck(copySubActions);
           
    
        }
    
    
        if (isActive) {
            copySubActions.push(item.slug);
        }
    
    
    
          await setSubActionCheck(copySubActions);
      
          copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked[item.slug] = !copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked[item.slug];
          await setModulesChecked(copyPermissionsChecked);
         
    
    
          
        
          
        
    
      }
    
    
    
      const setModulesPermissionsChildrenAction =  async(event:any, item:any, parent:string, action: string, elementParent:any) => {
    
          const isActive = event.target.checked;
    
          
    
          // CHECKED Y DESCHECKED 
    
              let copyPermissionsChecked = await JSON.parse(JSON.stringify(modulesChecked));
    
              
              //  TIENE CHILDRES 
              if ( copyPermissionsChecked[elementParent.permission_slug] && Object.keys(copyPermissionsChecked[elementParent.permission_slug].childrensChecked).length > 0 ) {
                  
                  if ( copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug]  ) {
                       
                       copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug][action] = !copyPermissionsChecked[elementParent.permission_slug].childrensChecked[item.slug][action];
                      
                  }
    
              }
    
              setModulesChecked(copyPermissionsChecked);
            // END CHECKED Y DESCHECKED 
            
            // slug
              // IF THE CHECKBOX IS ACTIVE AND EXIST ELEMENT PUSH CHILDRENS ACTIONS  ARRAY 
          if ( isActive && modules.find((element:any) => element.related === parent ) ) {
    
    
            let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
                  
                  if ( obj.related == parent ) {
                      
                      for (let index = 0; index < obj.childrens.length; index++) {
                      
                        if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {
                             obj.childrens[index].actions.push(action);
                        }
    
                      }
    
                  }
    
                  return obj;
              });
    
              await setModules(filteredPermissions);
    
          }
    
    
    
    
    
          // IF THE CHECKBOX IS NOT ACTIVE AND  EXIST ELEMENT PUSH ELEMENT REMOVE CHILDRENS ACTIONS  ARRAY 
          if ( !isActive && modules.find((element:any) => element.related === parent )  ) {
    
          
            let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
                  
                  if ( obj.related == parent ) {

                      for (let index = 0; index < obj.childrens.length; index++) {
                       
                        if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {


                            obj.childrens[index].actions = obj.childrens[index].actions.filter(elemento => elemento != action);
                         
    
                        }
    
                      }
    
                  }
    
                  return obj;
              });

    
              await setModules(filteredPermissions);
    
          }
    
    
            
      }
    
    
      
      
    
      
      
    
    
    
      const setModulesPermissionsWithChildren = async(event:any, item:any, parent:string, action:string, elementParent:any) => {
    
        const isActive = event.target.checked;
    
        
       
        
        // PONEMOS CHECK EN FALSO PARA TODAS LAS ACCIONES DE ESTE SUB MODULO  
        let copyPermissionsChecked = await JSON.parse(JSON.stringify(modulesChecked));
        let copyActions = await JSON.parse(JSON.stringify(actionCheck));
        
    
    
    
        
    
        if (!isActive) {
            //  SUBCHILDRENS OF CHILDRES ACTIONS
     
            
           await  uncheckAllSubChuldrensFromParentSubmodule(copyPermissionsChecked, elementParent)
            
        }
    
      
        if ( !isActive ) { 
    
            if ( item.childrens && item.childrens.length > 0  ) {
    
              
               
              item.childrens.forEach( (elementChildren:any) => {
    
                let element = copyActions.indexOf(elementChildren.slug);
    
                if (element !== -1) {
                    copyActions.splice(element, 1);
                }
    
                
              });      
              setActionCheck(copyActions);   
            } // END IF
             
          
          setModulesChecked(copyPermissionsChecked);
    
        } // END IF
     
    
        if ( isActive ) { 
    
          if ( item.childrens && item.childrens.length > 0  ) {
             
                item.childrens.forEach( (elementChildren:any) => {
    
                  let element = copyActions.indexOf(elementChildren.slug);
    
                  if (element == -1) {
                      copyActions.push(elementChildren.slug);
                  }
                   
                }); 
                setActionCheck(copyActions);
    
          } // END IF
           
        } // END IF
         
         
          
          copyPermissionsChecked[elementParent.permission_slug].subModulesChecked[item.slug] = !copyPermissionsChecked[elementParent.permission_slug].subModulesChecked[item.slug];
          setModulesChecked(copyPermissionsChecked);
    
          
      
    
         // IF THE CHECKBOX IS ACTIVE AND EXIST ELEMENT PUSH CHILDRENS  ARRAY 
        if ( isActive && modules.find((element:any) => element.related === parent ) ) {
    
          
          // SE PONE EN ESTE CASO PORQUE COMO TIENE SUBCHILDRENS NO LO PONGA 2 VECES EN EL ARRAY 
          let existAlready = false;
          let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
                
                if ( obj.related == parent ) {
                 
    
                     const isObjectPresent = obj.childrens.find((o) => o.slug === item.slug);
                     
                     if (!isObjectPresent) {
                        const depeedItem = JSON.parse(JSON.stringify(item));
                        depeedItem.parent = parent;
                        obj.childrens.push(depeedItem);
                     }
                     
                }
    
                return obj;
              }); // END MAP 
    
            await setModules(filteredPermissions);
    
        } // END IF 
    
        
    
    
    
        // IF THE CHECKBOX IS NOT ACTIVE AND  EXIST ELEMENT PUSH ELEMENT TO ARRAY 
        if ( !isActive && modules.find((element:any) => element.related === parent ) ) {
    
          let filteredPermissions = modules.map(function (obj:IModulesPermissions, index:any) {
                
            if ( obj.related == parent ) {
                   
    
                  for (let index = 0; index < obj.childrens.length; index++) {
                    
                      if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {
                           obj.childrens.splice(index, 1);
                      }
    
                  } // END FOR
    
            } // END IF
    
            return obj;
    
          }); // END MAP
    
          await setModules(filteredPermissions);
    
    
        } // END IF
    
        
        let filteredPermissions = modules.map(function (obj:any) {
                  
                  
    
                  for (let index = 0; index < obj.childrens.length; index++) {
                       
                       if ( obj.childrens[index].slug == item.slug ) {
                           
                            for (let i = 0; i < obj.childrens[index].childrens.length; i++) {
                              
                                 obj.childrens[index].childrens[i].actions = [];
                              
                            }
                       }
                      
                    
                  }
                  
    
                  return obj;
        });
        await setModules(filteredPermissions);
    
    
      }
        
    
      const  uncheckAllSubChuldrensFromParentSubmodule = async (copyPermissionsChecked:any, elementParent:any) => {
        
        // let copyPermissionsChecked = await JSON.parse(JSON.stringify(modulesChecked));
        let copySubActions     = await JSON.parse(JSON.stringify(subActionCheck));
    
    
        for (const property in copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked) {
          
          copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked[property] = false;
          
      
        }
        
        for (const property in copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked) {
          
    
          copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[property].view = false;
          copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[property].create = false;
          copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[property].edit = false;
          copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[property].restore = false;
          copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[property].delete = false;
      
        }
    
    
        
      
        copySubActions = [];
        await setSubActionCheck(copySubActions);
        await setModulesChecked(copyPermissionsChecked);
        
      }
      
    
      
      const setSubModulesPermissionsChildrenAction =  async(mainParent:any, event:any, item:any, parent:string, action: string, elementParent:any) => {
    
        const isActive = event.target.checked;
    
    
        // falta poner actions a cada elemento aqui 
    
    
        // CHECKED Y DESCHECKED 
        
            let copyPermissionsChecked = await JSON.parse(JSON.stringify(modulesChecked));
    
            
         
            //  TIENE CHILDRES 
            if ( copyPermissionsChecked[elementParent.permission_slug] && Object.keys(copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked).length > 0 ) {
                
                if ( copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug]  ) {
                     copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug][action] = !copyPermissionsChecked[elementParent.permission_slug].subChildrensCheked[item.slug][action];
                     setModulesChecked(copyPermissionsChecked);
                }
    
            }
    
        
          // END CHECKED Y DESCHECKED 
          
    
          if ( isActive ) {
    
          
            // SE PONE EN ESTE CASO PORQUE COMO TIENE SUBCHILDRENS NO LO PONGA 2 VECES EN EL ARRAY 
            let filteredPermissions = modules.map(function (obj:any) {
                  
                      
                    
                    
                      
                      for (let index = 0; index < obj.childrens.length; index++) {
                        
                        if (obj.childrens[index].slug == mainParent.slug) {
    
                            for (let i = 0; i < obj.childrens[index].childrens.length; i++) {
                                
                                 
                                 if (obj.childrens[index].childrens[i].slug == item.slug) {
                                  obj.childrens[index].childrens[i].actions.push(action)
                                  
                                 }
                              
                            }
                       
                        }
                        
                      }
                      
    
      
                  return obj;
                }); // END MAP 
      
              await setModules(filteredPermissions);
      
          } // END IF 







          if ( !isActive ) {
    
          
            // SE PONE EN ESTE CASO PORQUE COMO TIENE SUBCHILDRENS NO LO PONGA 2 VECES EN EL ARRAY 
            let filteredPermissions = modules.map(function (obj:any) {
                  
                      
                    
                    
                      
                      for (let index = 0; index < obj.childrens.length; index++) {
                        
                        if (obj.childrens[index].slug == mainParent.slug) {
    
                            for (let i = 0; i < obj.childrens[index].childrens.length; i++) {
                                
                                 
                                 if (obj.childrens[index].childrens[i].slug == item.slug) {
                                  
             
                                  obj.childrens[index].childrens[i].actions = obj.childrens[index].childrens[i].actions.filter( (animal:any) => animal != action);
                                  // obj.childrens[index].actions = obj.childrens[index].actions.filter(animal => animal != action);
                                  // obj.childrens[index].childrens[i].actions.push(action)
                                  
                                 }
                              
                            }
                       
                        }
                        
                      }
                      
    
      
                  return obj;
                }); // END MAP 
      
              await setModules(filteredPermissions);
      
          } // END IF 
         
    
          
    }


  


  return (
    <>
    
        <Grid item xs={12} > 
            <Card
                sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: paddingCardsTables
                }}
                >


                <div>


                {

                 pemisssionsList.map((item:any, index:any) => ( 

  

                    <>
                        {
                        
                        item.childrens.length > 0 
                        ?
                            

                            <Card   sx={{  marginTop: 10, borderTop: 2, borderColor: '#192a56'  }} key={index}>
                            <Card >
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h5">
                                        { eachWordUpper(item.text) } <VerifiedIcon/>
                                        {/* { JSON.stringify(item) } */}
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        sx={{ color: 'text.secondary' }}
                                        key={index}
                                    >
                                        { eachWordUpper('Sub modulos y permisos') }
                                    </Typography>
                                    </CardContent>
                                
                                    <div > 

                                    {/* PERMISOS MODULO PADRE  */}
                                    <>
                                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                            <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox  onChange={ (e) => setModulesPermissionsParent(e, item) }   name={`mod_${item.permission_slug}`} />} label={'Habilitar modulo'} />
                                                </FormGroup>
                                            </div>
                                        </Box>
                                    </>
                                    {/* FIN PERMISOS MODULO PADRE  */}

                                    
                                        {item.childrens.map((element:any, indexf:any) => ( 

                                        <Accordion expanded={true} onChange={handleChange('panel1')} >
                                            <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                            >
                                            <Typography sx={{ color: 'text.secondary' }}>{ eachWordUpper('Habilitar opciones') }</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>

                                            
                                            

                                            <Box sx={{  display: 'flex', flexDirection: 'row' }}>
                                            <CardContent sx={{ flex: '1 0 auto' }}>
                                                <Typography component="div" variant="h5">
                                                {/* ELEMENT CHILDREN  */}
                                                { eachWordUpper(element.text) }
                                                </Typography>
                                                <Typography
                                                variant="subtitle1"
                                                component="div"
                                                sx={{ color: 'text.secondary' }}>
                                                {/* ELEMENT PARENT KNOWS PARENT MODULE TEXT  */}
                                                { eachWordUpper(item.text) }
                                                </Typography>
                                                <Typography
                                                variant="subtitle1"
                                                component="div"
                                                sx={{ color: 'text.secondary' }}
                                                >
                                                </Typography>
                                                
                                            </CardContent>


                                            


                                            


                                            { element.childrens && element.childrens.length > 0 ? 
                                            
                                                    
                                                    <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}> 

                                                                <FormGroup>                                                                       
                                                                <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subModulesChecked[element.slug] } inputProps={{ 'aria-label': 'controlled' }}  disabled={ mainCheck.includes(item.related) ? false : true }  onChange={ (e) => setModulesPermissionsWithChildren(e, element, item.related, 'view', item) }   name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                                </FormGroup>
                                                            </div>
                                                    </Box>
                                                    
                                        
                                            :

                                                <>
                                                <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                                {/* {JSON.stringify(modulesChecked[item.permission_slug].subModulesChecked[element.slug]) } */}
                                                                {/* { JSON.stringify(element) }   */}
                                                            <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subModulesChecked[element.slug] } inputProps={{ 'aria-label': 'controlled' }}  disabled={ mainCheck.includes(item.related) ? false : true }  onChange={ (e) => setModulesPermissionsChildren(e, element, item.related, 'view', item) }   name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                            </FormGroup>
                                                        </div>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                                                            
                                                <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                {/* { JSON.stringify(modulesChecked[item.permission_slug][item.permission_slug] ) } */}
                                                {/* { JSON.stringify(element.slug) } */}
                                                
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].childrensChecked[element.slug].view } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'view', item) }   name={`ver_${element.slug}`} />}  label={'Ver'} />
                                                    </FormGroup>
                                                </div>
                                                <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].childrensChecked[element.slug].create } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'create', item) }   name={`crear_${element.slug}`} />}  label={'Crear'} />
                                                    </FormGroup>
                                                </div>
                                                <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].childrensChecked[element.slug].edit } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'edit', item) }   name={`editar_${element.slug}`} />}  label={'Editar'} />
                                                    </FormGroup>
                                                </div>
                                                <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].childrensChecked[element.slug].delete } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'delete', item) }   name={`eliminar_${element.slug}`} />}  label={'Eliminar'} />
                                                    </FormGroup>
                                                </div>
                                                <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].childrensChecked[element.slug].restore } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'restore', item) }   name={`restore_${element.slug}`} />}  label={'Restaurar'} />
                                                    </FormGroup>
                                                </div>
                                                </Box>
                                                </>
                                            
                                            }
                                            
                                            
                                            
                                            </Box>
                                        
                                            </AccordionDetails>

                                        



                                            { element.childrens && element.childrens.length > 0 ?
                                                <>
                                                    { element.childrens.map((subItem:any, indexf:any) => ( 

                                                        <Accordion expanded={true} onChange={handleChange('panel1')} >
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel1bh-content"
                                                            id="panel1bh-header"
                                                        >
                                                            <Typography sx={{ color: 'text.secondary' }}>{ eachWordUpper('Habilitar opciones') }</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                        <Box sx={{  display: 'flex', flexDirection: 'row' }}>
                                                        <CardContent sx={{ flex: '1 0 auto' }}>
                                                        <Typography component="div" variant="h5">
                                                        {/* ELEMENT CHILDREN  */}
                                                        { eachWordUpper(subItem.text) }
                                                        </Typography>
                                                        <Typography
                                                        variant="subtitle1"
                                                        component="div"
                                                        sx={{ color: 'text.secondary' }}>
                                                        {/* ELEMENT PARENT KNOWS PARENT MODULE TEXT  */}
                                                        { eachWordUpper(item.text) } { ' > '} { eachWordUpper(element.text) }
                                                        </Typography>
                                                        <Typography
                                                        variant="subtitle1"
                                                        component="div"
                                                        sx={{ color: 'text.secondary' }}
                                                        >
                                                        </Typography>
                                                        
                                                    </CardContent>


                                                    <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                        {/* { JSON.stringify(actionCheck) } */}
                                                            <FormGroup>                                                                                                                                                                                                                                 
                                                                <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subSubModulesChecked[subItem.slug] } inputProps={{ 'aria-label': 'controlled' }}  disabled={ actionCheck.includes(subItem.slug) ? false : true }  onChange={ (e) => setModulesPermissionsSubModulesChildren(e, subItem, item.related, 'view', item) }   name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                            </FormGroup> 
                                                        </div>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                        
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                                                                                                                                                                {/* copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked[item.slug]                                                                                     */}
                                                        <FormGroup>                                            
                                                            <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subChildrensCheked[subItem.slug].view } disabled={ subActionCheck.includes(subItem.slug) ? false : true } onChange={ (e) => setSubModulesPermissionsChildrenAction(element, e, subItem, item.related, 'view', item) }   name={`ver_${element.slug}`} />}  label={'Ver'} />
                                                            </FormGroup>
                                                        </div>
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                        <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subChildrensCheked[subItem.slug].create } disabled={ subActionCheck.includes(subItem.slug) ? false : true } onChange={ (e) => setSubModulesPermissionsChildrenAction(element, e, subItem, item.related, 'create', item) }   name={`crear_${element.slug}`} />}  label={'Crear'} />
                                                            </FormGroup>
                                                        </div>
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                        <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subChildrensCheked[subItem.slug].edit } disabled={ subActionCheck.includes(subItem.slug) ? false : true } onChange={ (e) => setSubModulesPermissionsChildrenAction(element, e, subItem, item.related, 'edit', item) }   name={`editar_${element.slug}`} />}  label={'Editar'} />
                                                            </FormGroup>
                                                        </div>
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                        <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subChildrensCheked[subItem.slug].delete } disabled={ subActionCheck.includes(subItem.slug) ? false : true } onChange={ (e) => setSubModulesPermissionsChildrenAction(element, e, subItem, item.related, 'delete', item) }   name={`eliminar_${element.slug}`} />}  label={'Eliminar'} />
                                                            </FormGroup>
                                                        </div>
                                                        <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                        <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={ modulesChecked[item.permission_slug].subChildrensCheked[subItem.slug].restore } disabled={ subActionCheck.includes(subItem.slug) ? false : true } onChange={ (e) => setSubModulesPermissionsChildrenAction(element, e, subItem, item.related, 'restore', item) }   name={`restore_${element.slug}`} />}  label={'Restaurar'} />
                                                            </FormGroup>
                                                        </div>
                                                    </Box>

                                                    </Box>

                                                        </AccordionDetails>
                                                        </Accordion>

                                                    ))}
                                                </>
                                            : ''
                                            
                                            }
                                            
                                            

                                        </Accordion>

                                            
                                            


                                        ))}


                                    
                                    
                                    </div>
                                </Box>
                            </Card>
                            </Card>
                        :
                        ''
                        }
                        

                        
                    </>
  
))

}

                </div>
            
            </Card>
        </Grid>
    </>
  )
}
